module.exports = __webpack_public_path__ + "static/media/Load-50.d9e61859.svg";